import crudListStyle from './crudList'
import listTableStyle from './listTable'

export { crudListStyle, listTableStyle }



// WEBPACK FOOTER //
// ./src/styles/index.js